import type { IconNode } from '../types';

/**
 * @name cpu-ai
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMjB2MiIgLz4KICA8cGF0aCBkPSJNMTIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xNiA5djYiIC8+CiAgPHBhdGggZD0iTTE3IDIwdjIiIC8+CiAgPHBhdGggZD0iTTE3IDJ2MiIgLz4KICA8cGF0aCBkPSJNMiAxMmgyIiAvPgogIDxwYXRoIGQ9Ik0yIDE3aDIiIC8+CiAgPHBhdGggZD0iTTIgN2gyIiAvPgogIDxwYXRoIGQ9Ik0yMCAxMmgyIiAvPgogIDxwYXRoIGQ9Ik0yMCAxN2gyIiAvPgogIDxwYXRoIGQ9Ik0yMCA3aDIiIC8+CiAgPHBhdGggZD0iTTcgMjB2MiIgLz4KICA8cGF0aCBkPSJNNyAydjIiIC8+CiAgPHBhdGggZD0iTTggMTNoNCIgLz4KICA8cGF0aCBkPSJNOCAxNXYtNGEyIDIgMCAwMTQgMHY0IiAvPgogIDxyZWN0IHg9IjQiIHk9IjQiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgcng9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/cpu-ai
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CpuAi: IconNode = [
  ['path', { d: 'M12 20v2' }],
  ['path', { d: 'M12 2v2' }],
  ['path', { d: 'M16 9v6' }],
  ['path', { d: 'M17 20v2' }],
  ['path', { d: 'M17 2v2' }],
  ['path', { d: 'M2 12h2' }],
  ['path', { d: 'M2 17h2' }],
  ['path', { d: 'M2 7h2' }],
  ['path', { d: 'M20 12h2' }],
  ['path', { d: 'M20 17h2' }],
  ['path', { d: 'M20 7h2' }],
  ['path', { d: 'M7 20v2' }],
  ['path', { d: 'M7 2v2' }],
  ['path', { d: 'M8 13h4' }],
  ['path', { d: 'M8 15v-4a2 2 0 014 0v4' }],
  ['rect', { x: '4', y: '4', width: '16', height: '16', rx: '2' }],
];

export default CpuAi;
